import { Model } from 'katal3-lib';
export class Store extends Model {
    update(httpStore) {
        super.update(httpStore);
    }
}
